// import { Link } from "react-router-dom";
// import { NAV_LINKS, APP_NAME, APP_TAGLINE } from "../../constants";


// const QUICK_LINKS = NAV_LINKS.slice(0, 5);


// export default function Footer() {
//   return (
//     <footer className="relative overflow-hidden" style={{ background: "#222831", borderTop: "1px solid rgba(148,137,121,0.14)" }}>

//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@300;400;500;600;700&family=Syne:wght@400;600;700;800&display=swap');
//       `}</style>

//       {/* Ambient Glow */}
//       <div className="absolute bottom-0 left-1/4 w-72 h-40 rounded-full blur-3xl pointer-events-none" style={{ background: "rgba(223,208,184,0.05)" }} />
//       <div className="absolute bottom-0 right-1/4 w-72 h-40 rounded-full blur-3xl pointer-events-none" style={{ background: "rgba(148,137,121,0.07)" }} />

//       <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 pt-8 pb-5">

//         {/* Footer Grid */}
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-8 lg:gap-16 mb-8">

//           {/* Brand Section */}
//           <div className="max-w-md">
//             <div className="flex items-center gap-3 mb-3">

//               <div className="leading-none">
//                 <p
//                   className="text-xl lg:text-2xl font-black tracking-wider"
//                   style={{ fontFamily: "'Syne', sans-serif", color: "#F5F0E8" }}
//                 >
//                   ViralOmics
//                 </p>
//               </div>
//             </div>

//             <p className="text-sm leading-relaxed" style={{ color: "rgba(245,240,232,0.45)" }}>
//               {APP_TAGLINE}. A comprehensive resource for viral transcriptomics,
//               inflammatory signatures, and systems biology.
//             </p>
//           </div>

//           {/* Navigation */}
//           <div className="sm:ml-auto">
//             <h4
//               className="text-xs font-bold tracking-[0.2em] uppercase mb-4"
//               style={{ fontFamily: "'Space Grotesk', sans-serif", color: "#948979" }}
//             >
//               Navigation
//             </h4>

//             <ul className="space-y-2">
//               {QUICK_LINKS.map((link) => (
//                 <li key={link.path}>
//                   <Link
//                     to={link.path}
//                     onClick={() => {
//                       if (link.label === "Home") {
//                         window.location.href = "/viralomics";
//                       }
//                     }}
//                     className="text-sm transition-colors duration-200 flex items-center gap-2 group"
//                     style={{ color: "rgba(245,240,232,0.45)" }}
//                     onMouseEnter={(e) => (e.currentTarget.style.color = "#DFD0B8")}
//                     onMouseLeave={(e) => (e.currentTarget.style.color = "rgba(245,240,232,0.45)")}
//                   >
//                     <span
//                       className="w-1 h-1 rounded-full transition-colors duration-200"
//                       style={{ background: "rgba(223,208,184,0.3)" }}
//                     />

//                     {link.label}
//                   </Link>
//                 </li>
//               ))}
//             </ul>
//           </div>
//         </div>

//         {/* Bottom Divider */}
//         <div
//           className="pt-4 flex flex-col sm:flex-row items-center justify-between gap-2"
//           style={{ borderTop: "1px solid rgba(148,137,121,0.1)" }}
//         >

//           <p
//             className="text-[11px] sm:text-xs text-center sm:text-left"
//             style={{ fontFamily: "'Space Grotesk', sans-serif", color: "rgba(245,240,232,0.3)" }}
//           >
//             © {new Date().getFullYear()} {APP_NAME} · All Rights Reserved
//           </p>
//         </div>
//       </div>
//     </footer>
//   );
// }


import { Link } from "react-router-dom";
import { NAV_LINKS, APP_NAME, APP_TAGLINE } from "../../constants";

const QUICK_LINKS = NAV_LINKS.slice(0, 5);

export default function Footer() {
  return (
    <footer
      className="relative overflow-hidden"
      style={{
        background: "#F1F5F9",
        borderTop: "1px solid rgba(100,116,139,0.16)",
      }}
    >

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Source+Serif+4:wght@500;600;700&display=swap');
      `}</style>

      {/* Ambient Glow */}
      <div
        className="absolute bottom-0 left-1/4 w-72 h-40 rounded-full blur-3xl pointer-events-none"
        style={{
          background: "rgba(15,118,110,0.035)",
        }}
      />

      <div
        className="absolute bottom-0 right-1/4 w-72 h-40 rounded-full blur-3xl pointer-events-none"
        style={{
          background: "rgba(100,116,139,0.04)",
        }}
      />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 pt-8 pb-5">

        {/* Footer Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-8 lg:gap-16 mb-8">

          {/* Brand Section */}
          <div className="max-w-md">
            <div className="flex items-center gap-3 mb-3">

              <div className="leading-none">
                <p
                  className="text-xl lg:text-2xl font-bold tracking-wide"
                  style={{
                    fontFamily: "'Source Serif 4', serif",
                    color: "#172B4D",
                  }}
                >
                  ViralOmics
                </p>
              </div>

            </div>

            <p
              className="text-sm leading-relaxed"
              style={{
                fontFamily: "'Inter', sans-serif",
                color: "rgba(23,43,77,0.62)",
              }}
            >
              {APP_TAGLINE}. A comprehensive resource for viral transcriptomics,
              inflammatory signatures, and systems biology.
            </p>
          </div>

          {/* Navigation */}
          <div className="sm:ml-auto">

            <h4
              className="text-xs font-bold tracking-[0.2em] uppercase mb-4"
              style={{
                fontFamily: "'Inter', sans-serif",
                color: "#0F766E",
              }}
            >
              Navigation
            </h4>

            <ul className="space-y-2">
              {QUICK_LINKS.map((link) => (
                <li key={link.path}>

                  <Link
                    to={link.path}
                    onClick={() => {
                      if (link.label === "Home") {
                        window.location.href = "/viralomics";
                      }
                    }}
                    className="text-sm transition-colors duration-200 flex items-center gap-2 group"
                    style={{
                      fontFamily: "'Inter', sans-serif",
                      color: "rgba(23,43,77,0.58)",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.color = "#0F766E")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.color = "rgba(23,43,77,0.58)")
                    }
                  >

                    <span
                      className="w-1 h-1 rounded-full transition-colors duration-200"
                      style={{
                        background: "rgba(15,118,110,0.35)",
                      }}
                    />

                    {link.label}

                  </Link>

                </li>
              ))}
            </ul>

          </div>

        </div>

        {/* Bottom Divider */}
        <div
          className="pt-4 flex flex-col sm:flex-row items-center justify-between gap-2"
          style={{
            borderTop: "1px solid rgba(100,116,139,0.12)",
          }}
        >

          <p
            className="text-[11px] sm:text-xs text-center sm:text-left"
            style={{
              fontFamily: "'Inter', sans-serif",
              color: "rgba(23,43,77,0.45)",
            }}
          >
            © {new Date().getFullYear()} {APP_NAME} · All Rights Reserved
          </p>

        </div>

      </div>
    </footer>
  );
}